import { createFeatureSelector, createSelector } from '@ngrx/store';

import { POSTFNOL_FEATURE_KEY, PostFnolState } from './post-fnol.reducer';

// Lookup the 'PostFnol' feature state managed by NgRx
const getPostFnolState = createFeatureSelector<PostFnolState>(POSTFNOL_FEATURE_KEY);

export const getPostFnolContext = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.context
);
export const getPostFnolClaimNumber = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.claimNumber
);
export const getPostFnolPolicyNumber = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.policyNumber
);
export const getPostFnolCustomerId = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.customerId
);
export const getPostFnolName = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.name
);
export const getPostFnolUserId = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.userId
);
export const getPostFnolExposureId = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.exposureId
);
export const getPostFnolVin = createSelector(getPostFnolState, (state: PostFnolState) => state.vin);
export const getPostFnolEmailAddress = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.emailAddress
);
export const getPostFnolGarageZipcode = createSelector(
  getPostFnolState,
  (state: PostFnolState) => state.garageZipcode
);

export const postFnolQuery = {
  getPostFnolContext,
  getPostFnolState,
  getPostFnolClaimNumber,
  getPostFnolPolicyNumber,
  getPostFnolCustomerId,
  getPostFnolName,
  getPostFnolUserId,
  getPostFnolExposureId,
  getPostFnolVin,
  getPostFnolEmailAddress,
  getPostFnolGarageZipcode
};
